import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { EventComplete } from "../../../models/events/event-complete.model";


export const adminEventAdapter: EntityAdapter<EventComplete> = createEntityAdapter<EventComplete>({
    selectId: (x: EventComplete) => x.eventID.toString() || x.eventLink,
    sortComparer: (a,b) => new Date(b.eventStart).getDate() - new Date(a.eventStart).getDate()
});